export default "__VITE_ASSET__DtiBYR1y__"